import { ReactNode } from "react";

const DockButton = ({
  label,
  isActive,
  icon,
  iconActive,
  children,
}: {
  label: string;
  icon: ReactNode;
  iconActive: ReactNode;
  isActive: boolean;
  children?: ReactNode;
}) => {
  return (
    <>
      <label className={`swap swap-rotate ${isActive && "swap-active"}`}>
        <div className="swap-off">{icon}</div>
        <div className="swap-on">{iconActive}</div>
      </label>
      {children}
      <span className="dock-label">{label}</span>
    </>
  );
};
export default DockButton;
